import { DashboardLayout } from "@/components/DashboardLayout";
import { StatCard, PlaceholderCard } from "@/components/StatCard";
import { DASH } from "@/constants/testIds";
import { useAuth } from "@/context/AuthContext";

export default function DepartmentHeadDashboard() {
  const { user } = useAuth();
  return (
    <DashboardLayout title={`Welcome, ${user?.first_name || "Head"}.`} breadcrumbs={["Department", "Overview"]}>
      <div data-testid={DASH.root("department-head")} className="space-y-8">
        <section className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <StatCard label="Department Staff" value="—" icon="UsersRound" tone="navy" testKey="staff" note="Enable in Phase 4" index={0} />
          <StatCard label="Training Pending" value="—" icon="AlarmClock" tone="amber" testKey="pending" note="Enable in Phase 6" index={1} />
          <StatCard label="Training Completed" value="—" icon="Check" tone="green" testKey="completed" note="Enable in Phase 6" index={2} />
          <StatCard label="Failed Exams" value="—" icon="XCircle" tone="slate" testKey="failed" note="Enable in Phase 7" index={3} />
          <StatCard label="Certs Expiring" value="—" icon="Award" tone="amber" testKey="expiring" note="Enable in Phase 8" index={4} />
        </section>
        <section>
          <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>Department oversight — coming soon</h2>
          <div className="mt-4 grid gap-4 md:grid-cols-2">
            <PlaceholderCard title="Staff Progress" description="See each team member's current training and score." phase="Phase 6" icon="LineChart" />
            <PlaceholderCard title="Department Reports" description="Exportable PDF/Excel reports for accreditation audits." phase="Phase 9" icon="BarChart3" tone="green" />
          </div>
        </section>
      </div>
    </DashboardLayout>
  );
}
